import _classCallCheck from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background-color: transparent;\n  bottom: 0;\n  box-sizing: border-box;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: -1; /* move behind trigger button */\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  position: relative;\n  z-index: 1;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        content: '';\n        filter: drop-shadow(0 2px 4px ", ");\n        ", "\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  backface-visibility: hidden; /* fixes text flickering in Firefox */\n  margin: ", ";\n  ", "\n\n  opacity: ", ";\n  overflow: visible;\n  transform: ", ";\n  transform-origin: ", ";\n  transition: opacity ", ", transform ", ";\n  width: ", ";\n  z-index: ", ";\n\n  &::after {\n    ", "\n  }\n\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { Component, createRef } from 'react';
import styled, { css } from 'styled-components';
import { position as cssPosition, triangle, rgba } from 'polished';
import { Transition } from 'react-transition-group';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { property, zIndex, color } from '@scp/ui-shared/theme/variables';
import { getCSSUnitValue } from '@scp/ui-shared/theme/utils';
import { VisuallyHiddenElement } from '@scp/ui-shared/theme/resets';
import { Paper } from '@scp/ui-shared/components/Paper';
import { Portal } from '@scp/ui-shared/components/Portal';
import { hasKey } from '@scp/ui-shared/core/types';
import { getAbsolutePosCoordinates, getTriangleDirection, getPopoverPosCoordinates } from './utils'; // react-transition-group API

var TransitionState;

(function (TransitionState) {
  TransitionState["Entering"] = "entering";
  TransitionState["Entered"] = "entered";
  TransitionState["Exiting"] = "exiting";
  TransitionState["Exited"] = "exited";
})(TransitionState || (TransitionState = {}));

var TRANSITION_TIMEOUT = {
  enter: 0,
  exit: 450
};
var PROPS_TO_OMIT = ['visible', 'width', 'position', 'anchorCoordinates', 'open', 'triangleOffset', 'triangleWidth', 'triangleHeight', 'isVertical', 'offset'];

var generateTriangleStyles = function generateTriangleStyles(_ref) {
  var position = _ref.position,
      isVertical = _ref.isVertical,
      triangleOffset = _ref.triangleOffset,
      triangleWidth = _ref.triangleWidth,
      triangleHeight = _ref.triangleHeight;
  var pointingDirection = getTriangleDirection(position, isVertical);
  var width = getCSSUnitValue(triangleWidth);
  var height = getCSSUnitValue(triangleHeight);
  return css(_templateObject(), cssPosition.apply(void 0, ['absolute'].concat(_toConsumableArray(getAbsolutePosCoordinates(position, isVertical, {
    x: "-".concat(triangleHeight),
    y: triangleOffset
  })))), isVertical ? triangle({
    width: height,
    height: width,
    foregroundColor: color.palette.white,
    pointingDirection: pointingDirection
  }) : triangle({
    width: width,
    height: height,
    foregroundColor: color.palette.white,
    pointingDirection: pointingDirection
  }));
};

var ContentWrapper = styled(withoutProps(Paper, PROPS_TO_OMIT))(_templateObject2(), function (props) {
  return getCSSUnitValue(props.offset);
}, function (props) {
  return cssPosition.apply(void 0, ['fixed'].concat(_toConsumableArray(getPopoverPosCoordinates(props))));
}, function (props) {
  return props.visible ? 1 : 0;
}, function (props) {
  return props.noTransform ? 'none' : "scale(".concat(props.visible ? 1 : 0.01, ")");
}, function (props) {
  return props.position;
}, property.transition, property.transition, function (props) {
  return getCSSUnitValue(props.width);
}, zIndex.popover, function (props) {
  return !props.noTriangle && css(_templateObject3(), rgba(color.palette.black, 0.35), generateTriangleStyles);
});
var Content = styled.div(_templateObject4(), color.palette.white);
var Anchor = styled.div(_templateObject5());
/**
 * A generic popup/popover component. Should be controlled outside via `open` prop.
 * Should have container with position relative for calculation of coordinates
 *
 * @example ./__docs__/Popover.md
 */

export var Popover = /*#__PURE__*/function (_Component) {
  _inherits(Popover, _Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.apply(this, arguments);
    _this.openedBy = null;
    _this.anchorRef = createRef();
    _this.paperRef = createRef();
    _this.closeTriggerRef = createRef();
    _this.transitionRef = createRef();
    _this.prevActiveElement = null;

    _this.handleKeyDown = function (e) {
      if (!_this.props.open) return;

      if (e.key === 'Escape') {
        e.stopPropagation(); // avoid popover-inside-popover issues

        _this.props.onClose(); // Focus trigger that opened the popover after closing


        if (_this.openedBy) _this.openedBy.focus();
      } // For popovers with arrow navigation


      if (e.key === 'Tab') {
        if (!_this.prevActiveElement && !(document.activeElement === _this.paperRef.current)) {
          _this.props.onClose();

          if (_this.openedBy) _this.openedBy.focus();
        }
      }
    };

    _this.handleKeyUp = function (e) {
      if (!_this.props.open) return;

      if (e.key === 'Tab') {
        _this.prevActiveElement = document.activeElement;

        if (_this.closeTriggerRef.current === document.activeElement) {
          _this.props.onClose();

          if (_this.openedBy) _this.openedBy.focus();
        }
      }
    }; // Accessibility: focus popover after opening


    _this.focusPopover = function () {
      if (_this.paperRef.current) {
        _this.paperRef.current.focus();
      }
    };

    _this.closePopover = function () {
      if (!_this.props.open) return;

      _this.props.onClose();
    };

    _this.handleScroll = function (e) {
      if (!_this.props.open) return;
      if (!hasKey(e, 'target') || !(e.target instanceof Element)) return; // Check if scrolled element contains body or opened popover anchor

      if (e.target.contains(document.body) || e.target.contains(_this.anchorRef.current)) {
        _this.props.onClose();
      }
    };

    _this.renderContent = function (transitionState) {
      var _a = _this.props,
          children = _a.children,
          autoFocus = _a.autoFocus,
          noTriangle = _a.noTriangle,
          otherProps = __rest(_a, ["children", "autoFocus", "noTriangle"]);

      return React.createElement(ContentWrapper, Object.assign({
        visible: transitionState === 'entered',
        onKeyDown: _this.handleKeyDown,
        onKeyUp: _this.handleKeyUp,
        anchorCoordinates: _this.anchorCoordinates,
        ref: _this.paperRef,
        tabIndex: autoFocus ? 0 : undefined,
        padding: 0,
        noTriangle: noTriangle
      }, otherProps), React.createElement(Content, null, children), autoFocus && React.createElement(VisuallyHiddenElement, {
        ref: _this.closeTriggerRef,
        tabIndex: 0
      }));
    };

    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll, true);
      window.addEventListener('resize', this.closePopover);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, openedBy) {
      if (prevProps.open !== this.props.open && !!openedBy) {
        this.openedBy = openedBy;
      }

      if (this.props.autoFocus && !prevProps.open) {
        this.focusPopover();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll, true);
      window.removeEventListener('resize', this.closePopover);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        return document.activeElement;
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, React.createElement(Anchor, {
        ref: this.anchorRef
      }), React.createElement(Portal, null, React.createElement(Transition, {
        in: this.props.open,
        timeout: TRANSITION_TIMEOUT,
        unmountOnExit: true,
        mountOnEnter: true,
        nodeRef: this.transitionRef
      }, this.renderContent)));
    }
  }, {
    key: "anchorCoordinates",
    get: function get() {
      if (this.anchorRef.current) {
        return this.anchorRef.current.getBoundingClientRect();
      }

      return {};
    }
  }]);

  return Popover;
}(Component);
Popover.defaultProps = {
  open: false,
  children: null,
  width: 220,
  onClose: function onClose() {
    return null;
  },
  position: 'top left',
  isVertical: false,
  triangleOffset: 16,
  triangleWidth: 16,
  triangleHeight: 10,
  offset: 0,
  autoFocus: false
};